// extracted by mini-css-extract-plugin
export var closeButton = "_ft-2";
export var closeButtonIcon = "_ft-3";
export var lightboxContent = "_ft-1";
export var lightboxOverlay = "_ft-0";